import React from 'react';

import InboundShowView from '@components/shared/inbounds/InboundShow';
import { useOperatorInboundService } from '@hooks/operator/inbounds/useOperatorInboundService';
import { thirdPartyApiLogService } from '@services/operator/thirdPartyApiLogService';
import { valueAddedServiceService } from '@services/operator/valueAddedServiceService';
import { useLoaderData } from 'react-router-dom';

export default function InboundShow() {
  const inbound = useLoaderData();

  return (
    <InboundShowView
      inbound={inbound}
      useInboundService={useOperatorInboundService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      valueAddedServiceService={valueAddedServiceService}
      role="operator"
    />
  );
}
